import { Button, FormGroup, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import { useLists } from "../../context/listContext";
import "./index.css";
import { useEffect } from "react";

const SliderImageSelect = ({
  i,
  pos,
  data,
  pageList,
  argumentsList,
  finalImages,
  updateFinalImages,
}) => {
  const {
    productCategoriesBarList,
    productCategoriesList,
    productSubCategoriesList,
    productsList,
  } = useLists();
  const [argument_id, setArgument_id] = useState( data?.argument_id || "home_page");
  const [argument, setArgument] = useState( data?.argument || "page_id");
  const [argumentArray, setArgumentArray] = useState(pageList);
  const [file, setFile] = useState(null);
  const [details, setDetails] = useState(false);
  const newData = data["slider-images"][pos];

  const selectData = () => {
    console.log(finalImages);
    updateFinalImages(i, { file, argument, argument_id });
  };

  useEffect(() => {
    if ( data?.slider_type === "Tiles" && productCategoriesBarList.length > 0 && productCategoriesList.length > 0 && productSubCategoriesList.length > 0 && productsList.length > 0) {
        handleArgumentSelect(newData?.argument);
      }
  }, [data, productCategoriesBarList, productCategoriesList, productSubCategoriesList, productsList]);

  const handleArgumentSelect = (e) => {
    setArgument(e);
    switch (e) {
      case "page_id":
        setArgumentArray(pageList);
        setArgument_id("");
        break;
      case "product_category_bar_id":
        setArgument_id("");
        setArgumentArray(productCategoriesBarList.filter(el => el.is_active !== 0));
        break;
      case "product_category_id":
        setArgument_id("");
        setArgumentArray(productCategoriesList.filter(el => el.is_active !== 0));
        break;
      case "product_sub_category_id":
        setArgument_id("");
        setArgumentArray(productSubCategoriesList.filter(el => el.is_active !== 0));
        break;
      case "product_id":
        setArgument_id("");
        setArgumentArray(productsList.filter(el => el.is_active !== 0));
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    console.log("===> this is the newData", newData);
  }, [newData]);
  return (
    <>
      <div
        className={`flex w-[100%] flex-col p-2 relative ${
          details ? "dimmed" : ""
        } transition-all `}
      >
        <input type="file" onChange={(e) => setFile(e.target.files[0])} />
        {newData?.image_file || file ? (
          <img src={ newData?.image_file || URL.createObjectURL(file)} alt="ff" className="w-[100%] aspect-video" />
        ) : null}
        <FormGroup>
          <InputLabel id="demo-simple-select-label">Argument:</InputLabel>
          <Select
            id="demo-simple-select"
            value={argument}
            style={{ textAlign: "left" }}
            onChange={(e) => handleArgumentSelect(e.target.value)}
          >
            <MenuItem value={""}>--SELECT--</MenuItem>
            {argumentsList.map((bar) => {
              return (
                <MenuItem value={bar.key} key={bar.key}>
                  {bar.label}
                </MenuItem>
              );
            })}
          </Select>
        </FormGroup>
        <br />
        <FormGroup>
          <InputLabel id="demo-simple-select-label">Argument ID:</InputLabel>
          <Select
            id="demo-simple-select"
            value={argument_id}
            style={{ textAlign: "left" }}
            onChange={(e) => {
              setArgument_id(e.target.value);
              // if (!addImages) {
              //   setAddImages(true);
              // }
            }}
          >
            <MenuItem value={""}>--SELECT--</MenuItem>
            {argumentArray?.map((arg, i) => {
              return (
                <MenuItem value={arg[argument]} key={arg[argument]}>
                  {arg[argument.replace("_id", "_name")]}
                </MenuItem>
              );
            })}
          </Select>
        </FormGroup>
      </div>
      <Button
        disabled={!file || !argument || !argument_id}
        variant="contained"
        onClick={() => {
          setDetails((prev) => !prev);
          selectData();
        }}
        sx={{
          my: 2,
        }}
      >
        Set Details
      </Button>
    </>
  );
};

export default SliderImageSelect;
